import type { RunRecord } from "@/types/api/RunRecord"

export const REVIEWER_STATUS = {
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
} as const

export type ReviewerStatus =
  (typeof REVIEWER_STATUS)[keyof typeof REVIEWER_STATUS]

export type ConversationsTableResult = Pick<
  RunRecord,
  "agent_id" | "version_id" | "tags" | "customer_metadata"
> & {
  run_id: string
  simulation_output_id: string | null
  created_at: string
  occurred_at: string | null
  metrics: Record<string, number | string>
  explanations: Record<string, string>
  metadata: Record<string, unknown> | unknown[]
  notes: string
  error_status: string
  run_status: string
  metric_error_statuses: Record<string, string>
  metric_error_messages: Record<string, string>
  label_status: "UNLABELED" | "LABELED"
  reviewer_assignees?: string[]
  reviewer_status?: ReviewerStatus | null
}

export const TIMESTAMP_MODE = {
  CREATED_AT: "created_at",
  OCCURRED_AT: "occurred_at",
} as const
export type TimestampMode = (typeof TIMESTAMP_MODE)[keyof typeof TIMESTAMP_MODE]
